// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__38qxZ","imageUploader":"EGiftCard_imageUploader__1XpiT"};